const customizationBusinessIdsByApiEnvironment = [
  {
    apiUrlPattern: /ushow-api-dev-japaneast\.azurewebsites\.net/i,
    businessId: "19940716",
  },
  {
    apiUrlPattern: /apitest\.ushowpos\.com/i,
    // businessId: "3270000",
    businessId: "3270001",
  },
];

export default function (...businessIds) {
  const currentBusinessId = String(window.localStorage["BusinessId"] || "");
  const apiUrl = String(process.env.VUE_APP_API_URL || "");
  const environmentBusinessIds = customizationBusinessIdsByApiEnvironment
    .filter(({ apiUrlPattern }) => apiUrlPattern.test(apiUrl))
    .map(({ businessId }) => businessId);
  const configuredBusinessId = process.env.VUE_APP_CUSTOMIZATION_BUSINESS_ID;
  if (configuredBusinessId) {
    environmentBusinessIds.push(String(configuredBusinessId));
  }
  const customizationBusinessIds = businessIds
    .flat()
    .filter((businessId) => businessId !== null && businessId !== undefined)
    .map(String)
    .concat(environmentBusinessIds);

  return customizationBusinessIds.includes(currentBusinessId);
}
